export default class ProductStarsReview extends HTMLElement {
	constructor() {
		super();
		this.id = this.dataset.productId;
		this.data = null;
		this.globalRange = null;
		this.maxStars = 5;
		this.key = this.dataset.key;
	}

	async connectedCallback() {
		this.data = await this.fetchAllProductReviews();

		if (this.data) {
			this.render();
		}
	}

	async fetchAllProductReviews(offset = 0) {
		const apiStgUrl = 'https://stg.api.bazaarvoice.com/data/reviews.json';
		const apiUrl = 'https://api.bazaarvoice.com/data/reviews.json';
		const apiKey = 'cad847lJKr7DKxfmLjtst0fp08OP4tSwgBBXRYt7xDheg';
		const apiKeyProd = this.key;
		const apiVersion = '5.4';

		try {
			const response = await fetch(
				`${apiUrl}?apiversion=${apiVersion}&passkey=${apiKeyProd}&Filter=ProductId:${this.id}&Sort=Rating:desc&Offset=${offset}&Include=Products&Stats=Reviews`,
			);
			const data = await response.json();

			return data;
		} catch (error) {
			console.error('Erreur lors de la récupération des avis:', error);
		}
	}

	render() {
		if (this.data.Results.length === 0) {
			// no reviews
			// console.log('no reviews');
			this.hideStars();
		} else {
			this.initData();
			this.createStarsElement();
		}
	}

	initData() {
		// init data
		this.globalRange =
			this.data.Includes.Products[
				this.id
			].ReviewStatistics.AverageOverallRating.toFixed(1);
	}

	createStarsElement() {
		const insideStars = this.querySelector('[data-full-stars]');
		const pourcentage = 100 - (this.globalRange / this.maxStars) * 100;
		insideStars.style.clipPath = `inset(0 ${pourcentage}% 0 0)`;
	}

	hideStars() {
		// const elReviewStars = this.querySelector('[data-review-stars]');
		// elReviewStars.style.visibility = 'hidden';
		this.style.display = 'none';
	}

	disconnectedCallback() {}
}
